import { Box, Divider, Typography } from '@mui/material'
import { InfoWindow } from '@vis.gl/react-google-maps'
import { useEffect } from 'react'
import { RecordContextProvider, ResourceContextProvider, useResourceContext, useTranslate } from 'react-admin'

export const INFO_WINDOW_TRANSLATION_KEY = 'resources.vehicle-telematics.infoWindow'

export const AdvancedInfoWindow = ({ record, resource, header: Header, children, ...props }) => {
  useEffect(() => {
    const interval = setInterval(() => {
      const closeButton = document.querySelector('.gm-ui-hover-effect span')
      if (closeButton) {
        closeButton.style.backgroundColor = '#333'
        clearInterval(interval)
      }
    }, 100)

    return () => clearInterval(interval)
  }, [])

  return (
    <ResourceContextProvider value={resource}>
      <RecordContextProvider value={record}>
        <InfoWindow
          headerContent={
            <Box
              sx={{
                flexDirection: 'row',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                color: '#111',
                fontWeight: 700,
              }}
            >
              <Header />
            </Box>
          }
          {...props}
        >
          <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: 0.25 }}>{children}</Box>
        </InfoWindow>
      </RecordContextProvider>
    </ResourceContextProvider>
  )
}

export const InfoWindowDivider = () => (
  <Divider variant="middle" sx={{ my: 0.75, borderColor: 'rgba(0,0,0,0.1)', borderBottomWidth: 1 }} />
)

export const HeaderSection = ({ title, sx }) => {
  const translate = useTranslate()
  const resource = useResourceContext()
  return (
    <Typography
      variant="caption"
      sx={{ textTransform: 'uppercase', fontWeight: 600, color: '#999', letterSpacing: 0.5, mt: 1.5, mb: 0.5, ...sx }}
    >
      {translate(`resources.${resource}.infoWindow.sectionTitle.${title}`)}
    </Typography>
  )
}
